export default "__VITE_ASSET__CdxA1sn1__"